import { ContractsCatalog } from "../views/contractsCatalog/ContractsCatalog";
import { TabulatorsCatalog } from "../views/tabulatorsCatalog/TabulatorsCatalog";
import { PrePayroll } from "../views/PrePayroll/PrePayroll";
import { EmployeesCatalog } from "../views/employeesCatalog/EmployeesCatalog";

import { LibraryBooks } from "@material-ui/icons";

export const prePayRollRoutes = [
  {
      collapse: true,
      name: "Prenomina",
      icon: LibraryBooks,
      state: "prePayrollCollapse",
      inSidebar: true,
      isProtected: true,
      rule: "PREPAYROLL",
      views: [
        {
          path: "/contratos",
          name: "Contratos",
          mini: "CT",
          component: ContractsCatalog,
          layout: "/admin",
          inSidebar: true,
          isProtected: true,
          rule: "PREPAYROLL",
          noTitle: true,
        },
        {
          path: "/tabuladores",
          name: "Tabuladores",
          mini: "TB",
          component: TabulatorsCatalog,
          layout: "/admin",
          inSidebar: true,
          isProtected: true,
          rule: "PREPAYROLL",
          noTitle: true,
        },
        {
          path: "/pre_nomina",
          name: "PreNomina",
          mini: "PN",
          component: PrePayroll,
          layout: "/admin",
          inSidebar: true,
          isProtected: true,
          rule: "PREPAYROLL-MONITOR",
          noTitle: true,
        },
        {
          path: "/empleados",
          name: "Empleados",
          mini: "EM",
          component: EmployeesCatalog,
          layout: "/admin",
          inSidebar: true,
          isProtected: true,
          rule: "PREPAYROLL",
          noTitle: true,
        },
      ].sort((a, b) => (a.name < b.name ? -1 : 1)),
    },
]